import { render, staticRenderFns } from "./PanelInvoiceRemoveButton.vue?vue&type=template&id=dd3db4e6&scoped=true&"
import script from "./PanelInvoiceRemoveButton.vue?vue&type=script&lang=js&"
export * from "./PanelInvoiceRemoveButton.vue?vue&type=script&lang=js&"
import style0 from "./PanelInvoiceRemoveButton.vue?vue&type=style&index=0&id=dd3db4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3db4e6",
  null
  
)

export default component.exports